import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-records',
  templateUrl: './public-records.component.html',
  styleUrls: ['./public-records.component.css']
})
export class PublicRecordsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
